<template>
  <div class="mobile mwr2025-index" :style="{ 'visibility': changingFont ? 'hidden' : 'visible' }">
    <AudioPlayer />
    <router-view />
  </div>
</template>
<script setup>
/* eslint-disable no-unused-vars */
import { reactive, provide, computed, watch, ref } from 'vue'
import { useStore } from 'vuex'
import MwrActApi from '@/config/mwrActApi'
import { toastService } from '@/utils/toastService'
import { useRouter, useRoute } from 'vue-router'
import mwrActApi from '@/config/mwrActApi'
import { useI18n } from 'vue-i18n'
import AudioPlayer from './components/AudioPlayer/index.vue'
import '@/assets/mwr-font.css'
const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH

const router = useRouter()
const route = useRoute()
const store = useStore()
const { locale } = useI18n()
const changingFont = ref(false)

watch(() => locale.value, () => {
  // 如果语言改变，需要重新加载字体文件
  // changingFont.value = true
  // const fontLink = `<link rel="stylesheet" href="${PUBLIC_PATH}css/fonts/${locale.value}/font.css">`
  // document.head.innerHTML += fontLink
  // setTimeout(() => {
  //   changingFont.value = false
  // }, 1000)
})
if (store.state.cpUserInfo.token && !store.state.cpUserInfo.mwrToken) {
  store.commit('SET_CP_USER_INFO', {})
}
const getDefaultCommonConfig = () => {
  return {
    isActivityStart: true,
    isActivityEnd: false,
    totalScore: 20260,
    firstStageScore: 4052,
    secondStageScore: 10130,
    thirdStageScore: 20260,
    awardBoxList: [
      {
        stage: 1,
        name: '',
        score: 4052,
      },
      {
        stage: 2,
        name: '',
        score: 10130,
      },
      {
        stage: 3,
        name: '',
        score: 20260,
      }
    ],
    taskTypeCountMap: {
      dailyLogin: 1,
      dailyPlayThreeMode: 1,
      loginDaysGt3: 3,
      loginDaysGt7: 7,
      playedFiveNewMode: 5,
      shareMwr: 2
    }
  }
}

const getDefaultShootDetail = () => {
  return {
    totalDragonHp: 0,
    currentDragonHp: 0,
    totalUserDpsScore: 0,
    totalShotCount: 0,
    usedShotCount: 0
  }
}

const getDefaultTaskDetail = () => {
  return {
    countDetail: {
      loginDays: 0, // 累计登录天数
      dailyPlayedModeCount: 0, // 玩过新模式次数
      newModeCount: 0, // 每日体验了 几 种不同模式
    },
    dailyLogin: 0,
    dailyPlayThreeMode: 0,
    loginDaysGt3: 0,
    loginDaysGt7: 0,
    shareMwr: 0,
    playedFiveNewMode: 0
  }
}

const getDefaultStatsData = () => {
  return {
    cpUserId: '',
    currentRoleName: '',
    totalGameTime: 0, // 总游戏时间
    totalKillCount: 0, // 总击杀数
    alwaysPlayMode: 0, // 最常游玩的模式
    alwaysPlayModeTime: 0,  // 最常游玩的模式总时长
    maxRankScore: 0, // 最高枪战段位分
    maxSavageRankScore: 0, // 最高野人段位分
    maxBrRankScore: 0, // 最高吃鸡段位分
    maxWeaponId: 0, // 最高击杀最多的主武器ID
    maxLongWinningCount: 0, // 最长连胜局数
    maxLongLoginDays: 0, // 最长连续登录天数
    topFriendId: '', // 最默契队友
    topFriendNickname: '', // 最默契队友昵称
    totalWeaponCount: 0, // 拥有的武器和枪械总数
    totalAvtCount: 0, // 拥有的皮肤和自定义装扮总数
    userTitle: {
      isForty: 0, // 是否击败率前40%
      isTwenty: 0, // 是否击败率前20%
      isGame100: 0, // 是否全模式排名前100
      modeID: 0, // 最常游玩的模式
      weaponType: '', // 最常用武器类型
      is10WValue: 0, // 是否超过10w时尚评分
      is15WValue: 0, // 是否超过15w时尚评分
      is20WValue: 0 // 是否超过20w时尚评分
    }
  }
}

const getDefaultRecordList = () => {
  return []
}
const state = reactive({
  cpUserInfo: computed(() => store.state.cpUserInfo),
  commonConfig: getDefaultCommonConfig(),
  shootDetail: getDefaultShootDetail(),
  taskDetail: getDefaultTaskDetail(), // 0-未完成, 1-可领取, 2-已领取
  recordList: getDefaultRecordList(),
  statsData: getDefaultStatsData(),
  isDragonDead: false,
  showActTimeDialog: false
})

// 打龙更新总伤害
const updateTotalUserDpsScore = (score) => {
  state.shootDetail.totalUserDpsScore += score
  if (state.shootDetail.totalUserDpsScore >= state.commonConfig.totalScore) {
    state.shootDetail.totalUserDpsScore = state.commonConfig.totalScore
  }
}

// 更新usedShotCount
const updateUsedShotCount = () => {
  state.shootDetail.usedShotCount += 1
  if (state.shootDetail.usedShotCount >= state.shootDetail.totalShotCount) {
    state.shootDetail.usedShotCount = state.shootDetail.totalShotCount
  }
}

// 更新总射击次数
const updateTotalShotCount = (count) => {
  state.shootDetail.totalShotCount += count
}

// 更新分享任务状态
const updateShareTaskStatus = () => {
  if (state.taskDetail.shareMwr !== 0) {
    toastService.showSmall('Update share task status error')
    return
  }
  state.taskDetail.shareMwr = 1
}

// 更新任务状态
const updateTaskStatus = (key, status) => {
  state.taskDetail[key] = status
}

// 更新宝箱领取记录
const updateBoxRewardRecord = async () => {
  await getBoxRewardRecord()
}

// 获取用户统计数据
const getStatsData = async () => {
  if (!state.cpUserInfo.cpUserId) {
    state.statsData = getDefaultStatsData()
    return
  }
  const res = await MwrActApi.getStatsData()
  state.statsData = res
  const nickname = await getNickname(state.statsData.topFriendId)
  state.statsData.topFriendNickname = nickname || ''
}

// 获取公共配置
const getCommonConfig = async () => {
  // if (!state.cpUserInfo.cpUserId) {
  //   state.commonConfig = getDefaultCommonConfig()
  //   return
  // }
  const res = await MwrActApi.getCommonConfig()
  console.log(state.commonConfig.isActivityStart, 'state.commonConfig.isActivityStart')
  state.commonConfig = {
    ...res,
    firstStageScore: res.awardBoxList[0].score,
    secondStageScore: res.awardBoxList[1].score,
    thirdStageScore: res.awardBoxList[2].score,
  }
  if (!res.isActivityStart) {
    state.showActTimeDialog = true
  }
}

// 获取打龙信息
const getShootDetail = async () => {
  if (!state.cpUserInfo.cpUserId) {
    state.shootDetail = getDefaultShootDetail()
    return
  }
  const res = await MwrActApi.getShootDetail()
  state.shootDetail = res
  if (res.currentDragonHp <= 0 && res.totalDragonHp > 0) {
    state.isDragonDead = true
  }
}

// 获取任务明细
const getTaskDetail = async () => {
  if (!state.cpUserInfo.cpUserId) {
    state.taskDetail = getDefaultTaskDetail()
    return
  }
  const res = await MwrActApi.getTaskDetail()
  state.taskDetail = res
}

// 获取宝箱领取记录
const getBoxRewardRecord = async () => {
  if (!state.cpUserInfo.cpUserId) {
    state.recordList = getDefaultRecordList()
    return
  }
  const res = await MwrActApi.getBoxRewardRecord()
  state.recordList = res.recordList || getDefaultRecordList()
  // state.recordList = [] || getDefaultRecordList()
}

// 获取nickname
const getNickname = async (uid) => {
  if (!state.cpUserInfo.cpUserId) {
    return ''
  }
  if (!uid) {
    return ''
  }
  const res = await MwrActApi.loginNoLoading({
    cpUserId: uid
  })
  return res.cpNickName
}

// 检查url上的uid是否登录，如果登录则登录
const checkUrlLogin = async () => {
  const uid = route.query.uid
  console.log('checkUrlLogin uid', uid)
  if (!uid) {
    return
  }
  const res = await mwrActApi.loginNoLoading({
    cpUserId: uid
  })
  res.mwrToken = res.token
  if (res.cpUserId && res.cpNickName && res.accountNum && res.mwrToken) {
    store.commit('SET_CP_USER_INFO', res)
    // 把url上的uid和其他所有参数删除
    router.replace({
      query: {}
    })
  }
}

const init = async () => {
  await checkUrlLogin()
  getCommonConfig()
  getShootDetail()
  getTaskDetail()
  getBoxRewardRecord()
  getStatsData()
}

init()

const reset = () => {
  init()
}

watch(() => state.cpUserInfo, () => {
  reset()
}, { deep: true })

provide('mwrData', state)
provide('mwrFn', {
  updateTotalUserDpsScore,
  updateUsedShotCount,
  updateShareTaskStatus,
  updateTotalShotCount,
  updateTaskStatus,
  updateBoxRewardRecord
})

// setInterval(() => {
//   state.shootDetail.totalUserDpsScore += 1000
// }, 1000)
</script>

<style scoped lang="less" src="./mobile_style.less"></style>
